import React from 'react';
import { CheckIcon } from 'lucide-react';
import { panelStyle } from '../../utils/imagePanel';
const includes = ['Guía digital de 148 páginas, ilustrada paso a paso', '6 módulos en video con las técnicas en tiempo real', 'Test de porosidad y patrón imprimible', 'Acceso de por vida, con actualizaciones incluidas'];
export function MethodSection() {
  return <section className="border-b border-white/5 bg-ink py-20" aria-labelledby="method-title" data-id="element-62" data-mp="1sq8tcb62uufc">
      <div className="mx-auto grid w-full max-w-6xl gap-12 px-6 lg:grid-cols-[1.1fr_1fr] lg:items-center lg:gap-16" data-id="element-63" data-mp="1ss3e9phcmmjf">
        <div data-id="element-64" data-mp="21qox7lqqg3kq">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-gold" data-id="element-65" data-mp="21r6zaz02tc0k">El método</p>
          <h2 id="method-title" className="mt-4 font-display text-3xl text-cream sm:text-4xl" data-id="element-66" data-mp="1wrkmgqo5txsa">
            Curly Seducción es un sistema de seis pasos, no una lista de productos
          </h2>
          <p className="mt-4 max-w-prose text-sand" data-id="element-67" data-mp="387ir8icb1xnp">
            Empiezas por diagnosticar tu cabello y terminas con una rutina que te toma 15 minutos
            por lavado. Cada paso asume lo aprendido en el anterior, así que no hay nada que
            adivinar.
          </p>

          <ul className="mt-8 space-y-3" data-id="element-68" data-mp="1mnt6ixqmx0zf">
            {includes.map(item => <li key={item} className="flex items-start gap-3 text-cream" data-id="element-69" data-mp="1mlzzhhc40eqw">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-70" data-mp="1rme04ebdsmew" />
                <span data-id="element-71" data-mp="u0qe8ncjxmhm">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="h-72 w-full rounded-lg border border-white/10 lg:h-[28rem]" style={panelStyle(1)} role="img" aria-label="El ebook Curly Seducción en libro impreso, tablet y celular junto a un aceite capilar" data-id="element-72" data-mp="yyruz1mi99px" />
      </div>
    </section>;
}